export type PaddingValue = string | number;
export type PaddingObject = {
    top: PaddingValue;
    right: PaddingValue;
    bottom: PaddingValue;
    left: PaddingValue;
};
export type Padding = PaddingValue | Partial<PaddingObject>;

const getValue = (value: PaddingValue | undefined, defaultValue: string | number): string => {
    const effectiveValue = value === undefined ? defaultValue : value;

    if (typeof effectiveValue === "number") {
        return `${effectiveValue}px`;
    }

    return effectiveValue;
};

export const getPadding = (padding: Padding | undefined, defaultValue: PaddingObject): string => {
    const isObject = typeof padding === "object";
    const top = getValue(isObject ? padding?.top : padding, defaultValue.top);
    const right = getValue(isObject ? padding?.right : padding, defaultValue.right);
    const bottom = getValue(isObject ? padding?.bottom : padding, defaultValue.bottom);
    const left = getValue(isObject ? padding?.left : padding, defaultValue.left);

    return `${top} ${right} ${bottom} ${left}`;
};
